import { withErrorBoundary } from "@sentry/react";

import ErrorFallback from "@components/error-fallback/error-fallback";
import IntegrationLogo from "@components/integration-logo/integration-logo";
import { classNames } from "@helpers/css";
import { isValidUrl } from "@helpers/helpers";

const AskAIEmbedExternalEventComponent = ({
  eventData, // dictionary with keys like "title", "url", "provider", etc
}: {
  eventData?: any;
}) => {
  const linkClassName = "hover:underline font-medium";

  // Get provider from eventData if available, otherwise default to topicflow
  const provider = eventData?.provider || "topicflow";

  return (
    <div className="flex gap-2 not-prose">
      <div className="mt-1 w-4 h-4">
        <IntegrationLogo provider={provider} className="block" />
      </div>
      <div className="flex-1">
        {eventData.url && isValidUrl(eventData.url) && eventData?.title ? (
          <a
            href={eventData.url}
            target="_blank"
            rel="noreferrer"
            className={linkClassName}
          >
            {eventData.title}
          </a>
        ) : eventData?.title ? (
          <span className={classNames(linkClassName, "hover:no-underline")}>
            {eventData.title}
          </span>
        ) : (
          <div className="w-64 skeleton rounded-md h-6" />
        )}
      </div>
    </div>
  );
};

const AskAIEmbedExternalEventWithSentry = withErrorBoundary(
  AskAIEmbedExternalEventComponent,
  {
    fallback: ErrorFallback,
  },
);

export default AskAIEmbedExternalEventWithSentry;
